// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3U6DC","footer":"ChangeClinic_footer__1HPft"};